

import { Component, Prop } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';
import { validationMixin } from 'vuelidate';
import { maxLength, minLength, required } from 'vuelidate/lib/validators';
import ErrorMessageHandlerMixin from '../misc/ErrorMessageHandler.mixin';

/**
 * Generic required-reason dialog, shared by every moderation flow (rating
 * hide / delete / restore, account block / unblock).
 *
 * The bounds mirror the backend validator exactly (trimmed, 3-500 chars) so a
 * value this dialog accepts can never be rejected server-side. The reason is
 * required by design: it is what lands in the activity log next to the action.
 */
@Component({
    mixins: [validationMixin],
    validations: {
        reason: { required, minLength: minLength(3), maxLength: maxLength(500) }
    }
})
export default class ReasonDialogComponent extends mixins(ErrorMessageHandlerMixin) {
    @Prop({ required: true })
    public title!: string;

    @Prop({ required: true })
    public text!: string;

    @Prop({ default: '' })
    public confirmLabel!: string;

    @Prop({ default: 'error' })
    public confirmColor!: string;

    @Prop({ default: false })
    public isLoading!: boolean;

    public reason: string = '';

    public checkForm(type: string) {
        this.triggerValidation(type);
    }

    public confirm() {
        this.$v.$touch();
        if (this.$v.$invalid) {
            return;
        }
        this.$emit('confirmed', this.reason.trim());
    }

    public dismiss() {
        this.$emit('closed');
    }
}

